import ProductList from '../components/HomeComponents/Products';
import HomepageImage from '../components/HomeComponents/HomepageImage';
import BottomBanner from '../components/LayoutComponents/BottomBanner';
import Footer from '../components/LayoutComponents/Footer';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import step1 from '../assets/images/steps/step1.jpg';
import step2 from '../assets/images/steps/step2.jpg';
import step3 from '../assets/images/steps/step3.jpg';

const Home = () => {
    const { t } = useTranslation();

    const features = [
        { icon: "icon-education-056", key: 'sustainabilityFeature' },
        { icon: "icon-finance-236", key: 'communityFeature' },
        { icon: "icon-education-045", key: 'accessibilityFeature' },
        { icon: "icon-travel-094", key: 'recycleFeature' }
    ];

    return (
        <div className="min-h-screen">
            <HomepageImage />
            
            <div className="container mx-auto px-4 py-8">

                {/* How It Works */}
                <section className="mb-16">
                    <h2 className="text-3xl font-bold mb-8 text-center">{t('howItWorks')}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {features.map((feature) => (
                            <div key={feature.key} className="text-center p-6 bg-white rounded-lg shadow-md">
                                <div className="text-4xl mb-4"><i className={`${feature.icon} u-line-icon-pro`}></i></div>
                                <h3 className="text-xl font-semibold mb-2">{t(feature.key)}</h3>
                                <p className="text-gray-600">{t(`${feature.key}Description`)}</p>
                            </div>
                        ))}
                    </div>
                </section>
                {/* What should you do? */}
                <section className="mb-16 mt-20">
                    <h2 className="text-3xl font-bold mb-20 text-center">{t('whatShouldYouDo')}</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {/* Step 1 */}
                        <div className="flex flex-col items-center">
                            <div className="relative mb-4 w-48 ">
                                <img 
                                    src={step1} 
                                    alt={t('step1Title')} 
                                    className="w-full h-full  rounded-lg "
                                />
                                <div className="absolute -top-4 -left-4 w-12 h-12 bg-[#3bb18f] text-white rounded-full flex items-center justify-center text-2xl font-bold">
                                    1
                                </div>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t('step1Title')}</h3>
                            <p className="text-center text-gray-600">{t('step1Description')}</p>
                        </div>

                        {/* Step 2 */}
                        <div className="flex flex-col items-center">
                            <div className="relative mb-4 w-48 ">
                                <img 
                                    src={step2} 
                                    alt={t('step2Title')} 
                                    className="w-full h-full  rounded-lg "
                                />
                                <div className="absolute -top-4 -left-4 w-12 h-12 bg-[#3bb18f] text-white rounded-full flex items-center justify-center text-2xl font-bold">
                                    2
                                </div>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t('step2Title')}</h3>
                            <p className="text-center text-gray-600">{t('step2Description')}</p>
                        </div>

                        {/* Step 3 */}
                        <div className="flex flex-col items-center">
                            <div className="relative mb-4 w-48 ">
                                <img 
                                    src={step3} 
                                    alt={t('step3Title')} 
                                    className="w-full h-full  rounded-lg "
                                />
                                <div className="absolute -top-4 -left-4 w-12 h-12 bg-[#3bb18f] text-white rounded-full flex items-center justify-center text-2xl font-bold">
                                    3
                                </div>
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t('step3Title')}</h3>
                            <p className="text-center text-gray-600">{t('step3Description')}</p>
                        </div>
                    </div>
                </section>
                {/* Available Books */}
                <ProductList />

                {/* Our Impact */}
                <section className="my-16 p-8 u-shadow-v20">
                    <h2 className="text-3xl font-bold mb-8 text-center">{t('environmentalImpact')}</h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        {t('environmentalImpactDescription')} 
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center mt-10">
                        <div>
                            <h4 className="text-2xl font-bold mb-2">{t('booksShared')}</h4>
                            <p className="text-gray-600">10,000+</p>
                        </div>
                        <div>
                            <h4 className="text-2xl font-bold mb-2">{t('activeCommunity')}</h4>
                            <p className="text-gray-600">5,000+</p>
                        </div>
                        <div>
                            <h4 className="text-2xl font-bold mb-2">{t('treeSaved')}</h4>
                            <p className="text-gray-600">500+</p>
                        </div>
                    </div>
                </section>
                
            </div>
            <BottomBanner />
        </div>
    );
};

export default Home;